/**
 * Money and date formatting for the proposals UI, matching what the server
 * prints into the document (`apps/api/src/lib/proposals/pricing.ts`): always
 * two decimals, discounts with an en dash.
 */

const MONEY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NUMBER = new Intl.NumberFormat('en-US');

/** `$9,500.00` */
export function formatMoney(value: number): string {
  return MONEY.format(value);
}

/** `– $950.00` */
export function formatDiscountAmount(value: number): string {
  return `– ${formatMoney(value)}`;
}

/** `1,200` */
export function formatCount(value: number): string {
  return NUMBER.format(value);
}

/** `Dec 10, 2026`, or an em dash for nothing / garbage. */
export function formatShortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? '—'
    : date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

/** The `yyyy-mm-dd` the DatePicker speaks, from an ISO timestamp. */
export function toDateInput(iso: string | null | undefined): string {
  return iso ? iso.slice(0, 10) : '';
}
